module.exports = __webpack_public_path__ + "static/media/verbandkasten_leosung.cec72140.png";